<template>
  <div class="">
    <CRow class="w-100">
      <CCol md="12" lg="12" sm="12" xs="12">
        <HomeMaintenceVue v-if="page == 'home'" @changePage="changePage" @setView="setView" />
        <RolesVue class="pt-1" v-if="page == 'roles'" @mtdBack="mtdBack" />
        <UsersVue class="pt-1" v-if="page == 'users'" @mtdBack="mtdBack" />
        <ClientVue class="pt-1" v-if="page == 'clients'" @mtdBack="mtdBack" />
        <CampusVue class="pt-1" v-if="page == 'campus'" @mtdBack="mtdBack" />
        <BoxVue class="pt-1" v-if="page == 'boxes'" @mtdBack="mtdBack" />
        <RecepcionistVue class="pt-1" v-if="page == 'recepcionists'" @mtdBack="mtdBack" />
        <ProductVue class="pt-1" v-if="page == 'products'" @mtdBack="mtdBack" />
        <UnitsVue class="pt-1" v-if="page == 'units'" @mtdBack="mtdBack" />
        <DocumentTypeVue class="pt-1" v-if="page == 'document_type'" @mtdBack="mtdBack" />
        <MethodPaymentVue class="pt-1" v-if="page == 'method_payment'" @mtdBack="mtdBack" />
        <ProveiderVue class="pt-1" v-if="page == 'provider'" @mtdBack="mtdBack" />
        <Personal class="pt-1" v-if="page == 'personal'" @mtdBack="mtdBack"/>
        <Projects class="pt-1" v-if="page == 'projects'" @mtdBack="mtdBack"/>
        <AlmacenVue class="pt-1" v-if="page == 'almacen'" @mtdBack="mtdBack" />
        <KitsVue class="pt-1" v-if="page == 'kits'" @mtdBack="mtdBack" />
        <!-- New -->
        <FloorsVue class="pt-1" v-if="page == 'level'" @mtdBack="mtdBack" />
        <TablesVue class="pt-1" v-if="page == 'tables'" @mtdBack="mtdBack" />
        <Categories class="pt-1" v-if="page == 'categories'" @mtdBack="mtdBack" />
        <Agreement class="pt-1" v-if="page == 'agreement'" @mtdBack="mtdBack" />
        <InsumosVue class="pt-1" v-if="page == 'insumos'" @mtdBack="mtdBack" />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import BoxVue from "../../components/maintenance/demo/Box.vue";
import CampusVue from "../../components/maintenance/demo/Campus.vue";
import ClientVue from '../../components/maintenance/demo/Client.vue';
import RecepcionistVue from "../../components/maintenance/demo/Recepcionist.vue";
import HomeMaintenceVue from "../../components/maintenance/demo/home.vue";
import ProductVue from "../../components/maintenance/aq/Product.vue"
import UnitsVue from "../../components/maintenance/demo/Unit.vue"
import RolesVue from "../access/roles.vue";
import UsersVue from "../access/users.vue";
import DocumentTypeVue from "../../components/maintenance/demo/DocumentType.vue";
import MethodPaymentVue from "../../components/maintenance/demo/MethodPayment.vue";
import ProveiderVue from "../../components/maintenance/demo/Proveider.vue";
import Personal from "../../components/maintenance/demo/personal/Personal.vue";
import Projects from "../../components/maintenance/demo/Projects.vue";
import AlmacenVue from "../../components/maintenance/demo/Almacen.vue";
import KitsVue from '../../components/maintenance/aq/Kits.vue';

import FloorsVue from "../../components/maintenance/demo/Floor.vue";
import TablesVue from "../../components/maintenance/demo/TableDrop.vue";
import Categories from "../../components/maintenance/demo/Category.vue";
import Agreement from "../../components/maintenance/demo/Agreement.vue";
import InsumosVue from "../../components/maintenance/demo/Insumos.vue";


export default {
  components: {
    HomeMaintenceVue,
    RolesVue,
    UsersVue,
    CampusVue,
    BoxVue,
    RecepcionistVue,
    ProductVue,
    UnitsVue,
    DocumentTypeVue,
    MethodPaymentVue,
    ProveiderVue,
    ClientVue,
    Personal,
    Projects,
    AlmacenVue,
    KitsVue,
    FloorsVue,
    TablesVue,
    Categories,
    Agreement,
    InsumosVue,
  },
  data() {
    return {
      page: "home",
    };
  },
  methods: {
    changePage: function (page) {
      this.page = page;
    },
    mtdBack: function () {
      this.page = 'home';
    },
    setView: function(){
      this.$emit('setView', 'home')
    }
  },
};
</script>
